var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.type === "edit" ? "编辑" : "新增",
        visible: _vm.dialog,
        width: _vm.getIsMobile ? "100%" : "50%",
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "before-close": _vm.handleClose,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialog = $event
        },
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "formRef",
          staticClass: "custom-form",
          attrs: {
            model: _vm.form,
            "label-width": "100px",
            "label-position": _vm.getIsMobile ? "top" : "right",
            rules: _vm.rules,
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "分类名称", prop: "classname" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入分类名称" },
                model: {
                  value: _vm.form.classname,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "classname", $$v)
                  },
                  expression: "form.classname",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "排序", prop: "wt" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入排序，越小越靠前" },
                model: {
                  value: _vm.form.wt,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "wt", $$v)
                  },
                  expression: "form.wt",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c("el-button", { on: { click: _vm.handleReset } }, [
            _vm._v("重 置"),
          ]),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.handleSubmit } },
            [_vm._v("确 定")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }